export default {
    BASE_URL: 'https://wsbo-online.meridianbet.com/api',
}
